import { STATUS_META } from "../_model";
import type { CompositionStatus } from "../_model";

interface ReadinessFlagProps {
  status: CompositionStatus;
  compact?: boolean;
}

export function ReadinessFlag({ status, compact }: ReadinessFlagProps) {
  if (status === "READY") return null;

  const working = status === "ANALYZING" || status === "RE-ANALYZING";
  const label = STATUS_META[status]?.label ?? status;
  const fg = working ? "#5c6f7d" : "#8a6a1e";
  const dotBg = working ? "#7d93a1" : "#c9a93b";

  return (
    <span
      title={
        working
          ? "Composition data is being processed — usable once ready."
          : "This mixture needs a chromatogram or formulation before N-OS can use it."
      }
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        fontSize: compact ? 10 : 11,
        fontWeight: 500,
        color: fg,
        whiteSpace: "nowrap",
      }}
    >
      <span style={{ position: "relative", width: 7, height: 7, flexShrink: 0 }}>
        <span
          style={{
            position: "absolute",
            inset: 0,
            borderRadius: "50%",
            background: dotBg,
            animation: working ? "slPulse 1.5s ease-in-out infinite" : "none",
          }}
        />
      </span>
      {label}
    </span>
  );
}
